import type { RsvpValue } from "@/lib/validation/auth";

export const RSVP_LABELS: Record<RsvpValue, string> = {
  yes: "Ja, ich bin dabei",
  no: "Nein, ich kann nicht",
  maybe: "Vielleicht",
};
